import './App.css';
import { SpeedInsights } from "@vercel/speed-insights/react"

function App() {
  return (
    <div>
      <SpeedInsights />
    </div>
  );
}

export default App;
